<template>
  <div class="row">
    <div class="col-xl-3">
      <select v-model="categoryFilter" class="form-control" v-on:change="getInventory()">
        <option value="">Categories</option>
        <option v-for="category in categories" v-bind:value="category.value">
          <p v-if="category.level === 2">&nbsp;&nbsp;&bullet;</p>
          <p v-if="category.level === 3">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&blacktriangleright;</p>
          {{category.name}}
        </option>
      </select>
    </div>
    <div class="col-xl-9">
      <ul class="pagination">
        <li class="page-item"><a v-on:click="setPage(currentPage - 1)" href="#" class="page-link">Prev</a></li>
        <li class="page-item" v-for="(page, index) in pages" v-bind:class="{ active: page.active }">
          <a v-if="index >= currentPage - 5 && (index < currentPage + 5 || index < 10)" v-on:click="setPage(index)" href="#" class="page-link">{{page.name}}</a>
        </li>
        <li class="page-item"><a v-on:click="setPage(currentPage + 1)" href="#" class="page-link">Next</a></li>
      </ul>
    </div>
    <div class="col-xl-12 row flex-row flex-nowrap">
      <table class="table table-bordered table-striped table-sm table-text-no-wrap">
        <thead>
        <tr>
          <th v-if="inventory_config.showFav">Fav</th>
          <th v-if="inventory_config.showName">Item Name</th>
          <th v-if="inventory_config.showWeight">Wgt (oz)</th>
          <th v-if="inventory_config.showInStock">Avail</th>
          <th v-if="inventory_config.showOrdered">Ord</th>
          <th v-if="inventory_config.showSalesOrder">SO</th>
          <th v-if="inventory_config.showWeight">Net Ava.</th>
          <th v-if="inventory_config.showPricing">Show</th>
          <th v-if="inventory_config.showPricing">DNS</th>
          <th v-if="inventory_config.showPricing">DNB</th>
          <th v-if="inventory_config.showPricing">Feat</th>
          <th v-if="inventory_config.showPricing">Melt+</th>
          <th v-if="inventory_config.showPricing">UQ∞</th>
          <th v-if="inventory_config.showPricing">QL</th>
          <th v-if="inventory_config.showPricing">QTY (QL)</th>
          <th v-if="inventory_config.showPricing">Pricing</th>
          <th v-if="inventory_config.showPricing">Bid (Prm)</th>
          <th v-if="inventory_config.showPricing">Ask (Prm)</th>
          <th v-if="inventory_config.showPricing" class="text-center">%</th>
          <th v-if="inventory_config.showPricing">Round</th>
          <th v-if="inventory_config.showBid" class="text-right">Bid (Price)</th>
          <th v-if="inventory_config.showCost" class="text-right">Avg Cost</th>
          <th v-if="inventory_config.showAsk" class="text-right">Ask (Price)</th>
          <th v-if="inventory_config.showPricing"></th>
          <th v-if="inventory_config.showBuy" class="text-center">Bid</th>
          <th v-if="inventory_config.showSell" class="text-center">Ask</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(item, index) in items">
          <td v-if="inventory_config.showFav" class="align-middle">
            <label class="switch switch-3d switch-icon switch-primary" style="margin-bottom: 0">
              <input v-model="item.fav" v-on:change="favorite(index)" type="checkbox" class="switch-input">
              <span class="switch-label"></span>
              <span class="switch-handle"></span>
            </label>
          </td>
          <td v-if="inventory_config.showName" class="align-middle">{{item.sales_desc}}</td>
          <td v-if="inventory_config.showWeight" class="align-middle">{{item.WC_OZWT | formatWeight}}</td>
          <td v-if="inventory_config.showWeight" class="align-middle">{{item.quantity_on_hand}}</td>
          <td v-if="inventory_config.showOrdered" class="align-middle">{{item.quantity_on_order}}</td>
          <td v-if="inventory_config.showSalesOrder" class="align-middle">{{item.quantity_on_sales_order}}</td>
          <td v-if="inventory_config.showSalesOrder" class="align-middle">{{item.quantity_on_hand + item.quantity_on_order -item.quantity_on_sales_order}}</td>
          <td v-if="inventory_config.showPricing" class="align-middle">
            <label class="switch switch-3d switch-success" style="margin-bottom: 0">
              <input v-model="item.display" v-on:change="setModified(index)" type="checkbox" class="switch-input">
              <span class="switch-label"></span>
              <span class="switch-handle"></span>
            </label>
          </td>
          <td v-if="inventory_config.showPricing" class="align-middle">
            <label class="switch switch-3d switch-danger" style="margin-bottom: 0">
              <input v-model="item.dns" v-on:change="setModified(index)" type="checkbox" class="switch-input">
              <span class="switch-label"></span>
              <span class="switch-handle"></span>
            </label>
          </td>
          <td v-if="inventory_config.showPricing" class="align-middle">
            <label class="switch switch-3d switch-danger" style="margin-bottom: 0">
              <input v-model="item.dnb" v-on:change="setModified(index)" type="checkbox" class="switch-input">
              <span class="switch-label"></span>
              <span class="switch-handle"></span>
            </label>
          </td>
          <td v-if="inventory_config.showPricing" class="align-middle">
            <label class="switch switch-3d switch-primary" style="margin-bottom: 0">
              <input v-model="item.feature" v-on:change="setModified(index)" type="checkbox" class="switch-input">
              <span class="switch-label"></span>
              <span class="switch-handle"></span>
            </label>
          </td>
          <td v-if="inventory_config.showPricing" class="align-middle">
            <label class="switch switch-3d switch-dark" style="margin-bottom: 0">
              <input v-model="item.melt_plus" v-on:change="setModified(index) | calculatePricing(index)" type="checkbox" class="switch-input">
              <span class="switch-label"></span>
              <span class="switch-handle"></span>
            </label>
          </td>
          <td v-if="inventory_config.showPricing" class="align-middle">
            <label class="switch switch-3d switch-success" style="margin-bottom: 0">
              <input v-model="item.is_unlimited" v-on:change="setModified(index)" type="checkbox" class="switch-input">
              <span class="switch-label"></span>
              <span class="switch-handle"></span>
            </label>
          </td>
          <td v-if="inventory_config.showPricing" class="align-middle">
            <label class="switch switch-3d switch-success" style="margin-bottom: 0">
              <input v-model="item.is_lc" v-on:change="setModified(index)" type="checkbox" class="switch-input">
              <span class="switch-label"></span>
              <span class="switch-handle"></span>
            </label>
          </td>
          <td v-if="inventory_config.showPricing" class="align-middle"><input min="0" type="number" v-model.number="item.lc_quantity" v-on:keyup="setModified(index)" class="form-control text-right form-control-sm" style="width: 80px"></td>
          <td v-if="inventory_config.showPricing" class="align-middle">
            <select v-model="item.pricing_type" v-on:change="calculatePricing(index) | setModified(index)" class="form-control form-control-sm">
              <option value="FIX">Fixed</option>
              <option value="GOLD">Gold</option>
              <option value="SILV">Silver</option>
              <option value="PLAT">Platinum</option>
              <option value="PALL">Palladium</option>
            </select>
          </td>
          <td v-if="inventory_config.showPricing" class="align-middle"><input v-model="item.premium_bid" v-on:keyup="calculatePricing(index) | setModified(index)" class="form-control text-right form-control-sm" style="width: 80px"></td>
          <td v-if="inventory_config.showPricing" class="align-middle"><input v-model="item.premium_ask" v-on:keyup="calculatePricing(index) | setModified(index)" class="form-control text-right form-control-sm" style="width: 80px"></td>
          <td v-if="inventory_config.showPricing" class="align-middle text-center">
            <label class="switch switch-text switch-dark" style="margin-bottom: 0">
              <input v-model="item.use_percent" v-on:change="setModified(index) | calculatePricing(index)" type="checkbox" class="switch-input">
              <span class="switch-label" data-on="%" data-off="$" ></span>
              <span class="switch-handle"></span>
            </label>
          </td>
          <td v-if="inventory_config.showPricing" class="align-middle">
            <select v-model="item.rounding" v-on:change="calculatePricing(index) | setModified(index)" class="form-control form-control-sm">
              <option value="0.01">.01</option>
              <option value="0.05">.05</option>
              <option value="0.1">.10</option>
              <option value="0.25">.25</option>
              <option value="0.5">.50</option>
              <option value="1">1.00</option>
              <option value="5">5.00</option>
            </select>
          </td>
          <td v-if="inventory_config.showBid" class="align-middle text-right">{{item.price_bid | currency}}</td>
          <td v-if="inventory_config.showCost" class="align-middle text-right">{{item.average_cost | currency | formatMissing}}</td>
          <td v-if="inventory_config.showAsk" class="align-middle text-right">{{item.price_ask | currency}}</td>
          <td v-if="inventory_config.showPricing" class="align-middle text-right">
            <button v-if="item.modified" v-on:click="saveItem(index)" type="button" class="btn btn-success btn-sm">Save</button>
            <button v-else="item.modified" type="button" class="btn btn-outline-secondary btn-sm" :disabled="true">Save</button>
          </td>
          <td v-if="inventory_config.showBuy" class="align-middle text-center">
            <button v-if="item.dnb" type="button" class="btn btn-primary" style="width: 140px;">
              Please Call
            </button>
            <button v-else="item.dnb" v-on:click="sellItem(index)" type="button" class="btn btn-primary" style="width: 140px;">
              {{item.price_bid | currency}}
              &nbsp;&nbsp;<i class="fa fa-plus-circle"></i>
              <br/>
              <span v-if="item.use_percent === 0">
                {{(Math.sign(item.premium_bid)  === 1 || item.premium_bid === 0) ?'+':'-'}}{{'$' + Math.abs(item.premium_bid)}} {{item.melt_plus ? ' per piece' : ' per ounce'}} 
              </span>
            </button>
          </td>
          <td v-if="inventory_config.showSell" class="align-middle text-center">
            <button v-if="item.dns" type="button" class="btn btn-success" style="width: 140px;">
              Please Call
            </button>
            <button v-else="item.dns" v-on:click="buyItem(index)" type="button" class="btn btn-success" style="width: 140px;">
              {{item.price_ask | currency}}
              &nbsp;&nbsp;<i class="fa fa-plus-circle"></i>
              <br/>
              <span v-if="item.use_percent === 0">
                {{(Math.sign(item.premium_ask)  === 1 || item.premium_ask === 0) ?'+':'-'}}{{'$' + Math.abs(item.premium_ask)}} {{item.melt_plus ? ' per piece' : ' per ounce'}}
              </span>
            </button>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
  import { pricing } from './mixins/pricing'

  export default {
    name: 'inventory',
    mixins: [pricing],
    props: {
      inventory_config: {default: null}
    },
    data () {
      return {
        categories: [],
        categoryFilter: '',
        items: [],
        allItems: [],
        currentPage: 0,
        spot_prices: null
      }
    },
    computed: {
      pages: function () {
        var currentPages = []
        for (var i = 0; i < this.allItems.length / this.inventory_config.pageSize; i++) {
          currentPages.push({name: i + 1, active: i === this.currentPage})
        }
        return currentPages
      }
    },
    filters: {
      formatWeight: function (value) {
        if (!value) return ''
        return parseFloat(value).toFixed(6)
      },
      formatMissing: function (value) {
        if (!value) return '—'
        if (value === '') return '—'
        return value
      }
    },
    watch: {
      items: function (newVal, oldVal) {
        this.priceItems()
      },
      spot_prices: function (newVal, oldVal) {
        this.priceItems()
      }
    },
    methods: {
      favorite (itemIndex) {
        this.$http.post('inventory/favorite', this.items[itemIndex]).then(response => {
          this.$bus.$emit('favorite-item', this.items[itemIndex])
        }, response => {
          console.log(response)
        })
      },
      buyItem (index) {
        document.body.classList.remove('aside-menu-hidden')
        this.$bus.$emit('buy-item', this.items[index])
      },
      sellItem (index) {
        console.log('sellItem -> this.items[index]', this.items[index])
        document.body.classList.remove('aside-menu-hidden')
        this.$bus.$emit('sell-item', this.items[index])
      },
      setPage (pageNum) {
        const maxPage = parseInt(this.allItems.length / this.inventory_config.pageSize)

        if (pageNum < 0) {
          this.currentPage = 0
        } else if (pageNum > maxPage) {
          this.currentPage = maxPage
        } else {
          this.currentPage = pageNum
        }

        const pageStart = this.currentPage * this.inventory_config.pageSize
        const pageEnd = pageStart + this.inventory_config.pageSize - 1
        this.items = this.allItems.slice(pageStart, pageEnd)
      },
      getInventory () {
        this.$http.get('inventory/search', {params: {category: this.categoryFilter, customer: this.inventory_config.customerFilter}}).then(response => {
          this.allItems = response.body
          this.items = this.allItems.slice(0, this.inventory_config.pageSize)
          this.currentPage = 0
        }, response => {
          console.log(response)
        })
      },
      priceItems () {
        for (var i = 0, len = this.items.length; i < len; i++) {
          console.log('priceItems -> this.items[i]', this.items[i])
          const currentPrice = this.priceItem(this.spot_prices, this.items[i])
          this.items[i].price_bid = currentPrice.bid
          this.items[i].price_ask = currentPrice.ask
        }
      },
      calculatePricing (index) {
        console.log('calculatePricing -> index', index)
        const currentPrice = this.priceItem(this.spot_prices, this.items[index])
        this.items[index].price_bid = currentPrice.bid
        this.items[index].price_ask = currentPrice.ask
      },
      saveItem (itemIndex) {
        this.$http.post('inventory/save', this.items[itemIndex]).then(response => {
          this.items[itemIndex].modified = false
        }, response => {
          console.log(response)
        })
      },
      setModified (itemIndex) {
        this.items[itemIndex].modified = true
        console.log('setModified -> this.items[itemIndex]', this.items[itemIndex])
      },
      getCategories () {
        this.$http.get('inventory/categories').then(response => {
          this.categories = response.body
        }, response => {
          console.log(response)
        })
      }
    },
    created () {
      this.$bus.$on('spot-price', ($event) => {
        if ($event['GOLD'] && $event['SILV'] && $event['PLAT'] && $event['PALL']) {
          this.spot_prices = $event
          if (this.allItems.length === 0) {
            this.getInventory()
          }
        } else {
          this.$bus.$emit('request-spot-price')
        }
      })
    },
    beforeMount () {
      this.getInventory()
      this.getCategories()
      this.$bus.$emit('request-spot-price')
    }
  }
</script>

<style>
  .table-text-no-wrap td {
    max-width: 280px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
</style>



// WEBPACK FOOTER //
// InventoryList.vue?43572f30